import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
    console.log("ERROR CAUGHT BY BOUNDARY:", error);
    console.log("Component Stack:", errorInfo.componentStack);
    // Try to extract component name from componentStack
    const componentMatch = errorInfo.componentStack.match(/\s+in\s+(\w+)/);
    const componentName = componentMatch ? componentMatch[1] : 'Unknown';
    console.log("Failed component:", componentName);
  }

  render() {
    if (this.state.hasError) {
      // Get component name if provided
      const componentName = this.props.componentName || 'Unknown Component';
      
      return (
        <div style={{ 
          padding: '20px', 
          margin: '20px', 
          backgroundColor: '#ffebee', 
          border: '1px solid #f44336',
          borderRadius: '4px' 
        }}>
          <h2>Component Error: {componentName}</h2>
          <details style={{ whiteSpace: 'pre-wrap' }} open>
            <summary>Show Error Details</summary>
            {this.state.error && this.state.error.toString()}
            <br />
            <br />
            <strong>Component Stack:</strong>
            <pre style={{ 
              backgroundColor: '#f5f5f5', 
              padding: '10px', 
              borderRadius: '4px',
              overflow: 'auto',
              maxHeight: '200px'
            }}>
              {this.state.errorInfo && this.state.errorInfo.componentStack}
            </pre>
          </details>
          <button 
            onClick={() => window.location.reload()}
            style={{
              marginTop: '20px',
              padding: '10px 15px',
              backgroundColor: '#2196f3',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Reload Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary; 